import Cookies from "js-cookie";


const CevizCookieConsent = function () {

    let gtagConsentOptions = {
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
    }

    function gtag() {
        dataLayer.push(arguments);
    }

    // all denied
    function gtagConsentAllDenied()
    {
        for (let key in gtagConsentOptions) {
            gtagConsentOptions[key] = 'denied';
        }
        gtag('consent', 'update', gtagConsentOptions);
    }

    // all granted
    function gtagConsentAllGranted()
    {
        for (let key in gtagConsentOptions) {
            gtagConsentOptions[key] = 'granted';
        }
        gtag('consent', 'update', gtagConsentOptions);
    }

    // specific consent
    function gtagConsentUpdater(consent = [], status = 'denied')
    {
        consent.forEach(function (e) {
            gtagConsentOptions[e] = status;
        });
        gtag('consent', 'update', gtagConsentOptions);
    }




    jQuery.fn.exists = function () {
        return this.length > 0;
    }

    const prefix = 'ceviz_cookie';



    var gtagInit = () => {

        window.dataLayer = window.dataLayer || [];
        let cookie = Cookies.get('cevizCookieConsent')

        gtag('consent', 'default', gtagConsentOptions);

        if (cookie === 'accept') {
            gtagConsentAllGranted();
        }

        if (cookie !== undefined) {
            if (cookie === 'accept') {
                gtagConsentAllGranted();
            } else if (cookie === 'reject') {
                gtagConsentAllDenied();
            } else {
                cookie = JSON.parse(decodeURIComponent(cookie));

                if (cookie.includes('reklamcilik')) {
                    gtagConsentUpdater(['ad_storage', 'ad_user_data', 'ad_personalization']);
                }

                if (cookie.includes('istatistik')) {
                    gtagConsentUpdater(['analytics_storage']);
                }
            }
        }

    }


    const tabs = () => {
        const wrapper = document.getElementById('CevizCookieSystem');
        if (!wrapper) return; // wrapper null ise çıkış yap

        wrapper.querySelectorAll(`.${prefix}_list_item`).forEach(function (e) {
            e.addEventListener('click', function (el) {
                document.querySelector(`.${prefix}_list_item_active`).classList.remove(`${prefix}_list_item_active`)
                document.querySelector(`.${prefix}_tab_content_active`).classList.remove(`${prefix}_tab_content_active`)

                let tab = e.getAttribute('data-tab');
                e.classList.add(`${prefix}_list_item_active`);
                wrapper.querySelector(tab).classList.add(`${prefix}_tab_content_active`);


            })
        })
    }

    const actions = () => {
        const wrapper = document.getElementById('CevizCookieSystem');
        if (!wrapper) return; // wrapper null ise çıkış yap

        document.querySelectorAll(`.${prefix}_renew`).forEach(function (el) {
            el.addEventListener('click', function () {
                Cookies.remove('cevizCookieConsent');
                window.location.reload();
            })
        });
        document.querySelectorAll(`.${prefix}_action_reject`).forEach(function (el) {
            el.addEventListener('click', function () {
                Cookies.set('cevizCookieConsent', "reject", {expires: 30});
                formPost();
                wrapper.classList.remove(`${prefix}_dialog_active`);

                let consent = document.querySelectorAll(`.${prefix}_consent`)
                consent.forEach(function (e) {
                    e.remove();
                })

                gtagConsentAllDenied();
            })
        })
        document.querySelectorAll(`.${prefix}_action_accept`).forEach(function (el) {
            el.addEventListener('click', function () {
                Cookies.set('cevizCookieConsent', "accept", {expires: 30});
                formPost();
                wrapper.classList.remove(`${prefix}_dialog_active`)

                let consent = document.querySelectorAll(`.${prefix}_consent`)
                consent.forEach(function (e) {
                    e.remove();
                })
                gtagConsentAllGranted();
            })
        })

        document.querySelectorAll(`.${prefix}_action_customize`).forEach(function (el) {
            el.addEventListener('click', function () {
                document.querySelector(`.${prefix}_list_item_active`).classList.remove(`${prefix}_list_item_active`)
                document.querySelector(`.${prefix}_tab_content_active`).classList.remove(`${prefix}_tab_content_active`)


                let consent = document.querySelectorAll(`.${prefix}_consent`)
                consent.forEach(function (e) {
                    e.remove();
                })


                let e = wrapper.querySelector(`.${prefix}_list_item_customize`)
                let tab = e.getAttribute('data-tab');
                e.classList.add(`${prefix}_list_item_active`);
                wrapper.querySelector(tab).classList.add(`${prefix}_tab_content_active`);
                wrapper.classList.add(`${prefix}_dialog_active`)
            })
        })

        wrapper.querySelector(`.${prefix}_action_selection`).addEventListener('click', function (e) {
            let list = [];
            wrapper.querySelectorAll(`.${prefix}_card_item`).forEach(function (e) {
                if (e.querySelector('input').checked) {
                    let name = e.querySelector('input').getAttribute('name');
                    list.push(name)

                    if (name === 'reklamcilik') {
                        gtagConsentUpdater(['ad_storage', 'ad_user_data', 'ad_personalization'], 'granted');
                    }

                    if (name === 'istatistik') {
                        gtagConsentUpdater(['analytics_storage'], 'granted');
                    }
                } else {
                    if (name === 'reklamcilik') {
                        gtagConsentUpdater(['ad_storage', 'ad_user_data', 'ad_personalization'], 'denied');
                    }

                    if (name === 'istatistik') {
                        gtagConsentUpdater(['ad_storage', 'ad_user_data', 'ad_personalization'],'denied');
                        (['analytics_storage']);
                    }
                }
            })
            Cookies.set('cevizCookieConsent', JSON.stringify(list), {expires: 30});
            formPost();
            wrapper.classList.remove(`${prefix}_dialog_active`)
        })

    }

    const formPost = () => {
        const wrapper = document.getElementById('CevizCookieSystem');
        if (!wrapper) return; // wrapper null ise çıkış yap

        let form = wrapper.querySelector('form.ceviz_cookie_form');
        fetch(form.getAttribute('action'), {
            method: 'POST',
            body: new FormData(form),
            cache: 'no-cache',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Data-Type': 'application/json'
            }
        }).then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                } else {
                }
            }).catch((error) => {
            // console.log(error.message)
        });

    }

    return {
        init: function () {
            gtagInit();

            fetch(window.siteurl.replace(/\/$/, "") + '/get-cookie-consent', {
                method: 'POST',
                cache: 'no-cache',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Data-Type': 'application/json'
                }
            }).then((response) => response.json())
                .then((data) => {
                    if (data.status) {
                        setTimeout(function () {
                            $('body').addClass('ceviz_cookie_active')
                            $('body').append(JSON.parse(data.cookie));

                            if (document.getElementById('CevizCookieSystem') == 'null')
                                return;


                            tabs();
                            actions();
                        }, 600)
                    }
                }).catch((error) => {
                console.log(error)
            });


            document.addEventListener('click', function (event) {
                const cookieActions = document.querySelector('.ceviz_cookie_actions');
                if (cookieActions && event.target.closest('.ceviz_cookie_actions button:not(.ceviz_cookie_action_customize)')) {
                    document.body.classList.remove('ceviz_cookie_active');
                }
            });
        }
    };
}();


jQuery(document).ready(function () {
    CevizCookieConsent.init();
});